// extracted by mini-css-extract-plugin
export default {"menuLinkContainer":"menuLink_menuLinkContainer__uk9JK","menuLink":"menuLink_menuLink__P9LVX","classLink":"menuLink_classLink__54Wo-","spacer":"menuLink_spacer__bRzYf"};